export function groupTours(tours) {
  return tours.map((t) => {
    const offer = {
      id: t.id,
      price_id: t.price_id,
      source_name: t.saved_from?.source_name,
      source_url: t.saved_from?.source_url,
      saved_at: t.saved_from?.saved_at,
      price: t.price,
      currency: t.currency,
      on_request: t.on_request,
      guaranteed: t.guaranteed,
      discount_type: t.discount_type,
      discount_value: t.discount_value,
      discount_amount: t.discount_amount,
      final_price: t.final_price,
      has_discount: t.has_discount,
    }

    return {
      ...t,
      offers: [offer],
      offerCount: 1,
      sourceCount: t.saved_from?.source_name ? 1 : 0,
      minPrice: offer.final_price ?? offer.price,
    }
  })
}
